export default "__VITE_ASSET__CADw4LLB__"